import axios from "axios";
import jstz from "jstz";
import utm from "./utm";

type UnifiedRegisterType = {
  apiUrl: string;
  _lang: string;
  country_id: number;
  entity: string;
  phone_number: string;
  password: string;
};

export type UnifiedResponseType = {
  client_id: number;
  profile_id: number;
  email?: string;
};

const apiInstance = axios.create({
  headers: {
    "Api-Client": "signup_web"
  }
});

export const registrationUnified = ({
  apiUrl,
  _lang,
  ...data
}: UnifiedRegisterType) =>
  apiInstance.post<UnifiedResponseType>(
    "/registration/unified/",
    {
      accept_terms: true,
      registration_reason: "default",
      registration_type: "email",
      timezone: jstz.determine().name(),
      ...data,
      ...utm
    },
    {
      baseURL: apiUrl,
      params: { _lang }
    }
  );

export const resendActivationEmail = ({
  apiUrl,
  email
}: {
  apiUrl: string;
  email: string;
}) =>
  apiInstance.post(
    "/activation_code/resend/",
    {
      email,
      domain_alias: "com",
      timezone: jstz.determine().name(),
      ...utm
    },
    {
      baseURL: apiUrl
    }
  );
